/** CDAP — Canada Digital Adoption Program (legacy / status tracking). */
export const CDAP_TASKS = [
  {
    id: 1,
    name: "Digital needs assessment",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm CDAP stream status and client eligibility", completed: false },
      { id: "1-2", name: "Complete digital adoption plan with advisor", completed: false },
    ],
  },
  {
    id: 2,
    name: "Grant & implementation",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Apply for Boost Your Business Tech grant if available", completed: false },
      { id: "2-2", name: "Select vendor and execute digital plan", completed: false },
    ],
  },
  {
    id: 3,
    name: "Close-out",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Submit proof of completion and invoices", completed: false },
      { id: "3-2", name: "Confirm reimbursement received", completed: false },
    ],
  },
];

/** OCI — Tech Demonstration / DMAP (Ontario Centre of Innovation). */
export const OCI_DMAP_TASKS = [
  {
    id: 1,
    name: "Demonstration project scope",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Confirm Ontario innovator + customer partner", completed: false },
      { id: "1-2", name: "Define technology demonstration milestones", completed: false },
    ],
  },
  {
    id: 2,
    name: "OCI application",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Draft technical and commercialization sections", completed: false },
      { id: "2-2", name: "Submit DMAP / Tech Demonstration application", completed: false },
    ],
  },
  {
    id: 3,
    name: "Project reporting",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Execute demo with industry partner", completed: false },
      { id: "3-2", name: "Submit OCI progress and financial claims", completed: false },
    ],
  },
];
